import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MuiAccordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { Card } from '@src/common/components/Card';
import { Typography } from '@src/common/components/Typography';
import type { ComponentProps } from 'react';

import { css } from '../styles/Styles';

type Props = {
  id: string;
  title: string;
} & ComponentProps<typeof MuiAccordion>;

export const Accordion = ({ id, title, children, ...props }: Props) => {
  return (
    <MuiAccordion
      id="parent"
      className={accordion}
      sx={{ all: 'unset', gap: 4, paddingTop: 2 }}
      {...props}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon className={expandIcon} />}
        aria-controls={id}
        id={id}
        className={subtitle}
      >
        <Typography className={accordionTitle}>{title}</Typography>
      </AccordionSummary>

      <AccordionDetails
        sx={{ display: 'flex', flex: 1 }}
        onClick={(e) => e.stopPropagation()}
      >
        <Card
          sx={{
            paddingY: '40px',
            paddingX: '30px',
            borderRadius: '12px',
            flexGrow: 1,
          }}
        >
          {children}
        </Card>
      </AccordionDetails>
    </MuiAccordion>
  );
};

const accordion = css(() => ({
  display: 'flex',
  '& > *:first-of-type': {
    minWidth: '300px',
  },
  '& > *:last-child': {
    flexGrow: 1,
  },
}));

const subtitle = css(() => ({
  flexDirection: 'row-reverse',
  padding: 0,
}));

const accordionTitle = css(() => ({
  fontWeight: 500,
  minWidth: 220,
}));

const expandIcon = css((theme) => ({
  marginRight: theme.spacing['1'],
}));
